import { useTranslation } from "react-i18next";

import { UpsertMissionForm } from "src/core/components/folder/missions/UpsertMissionForm";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "src/core/components/ui/dialog";
import { IMission } from "src/core/hooks/folder/useFolderMissions";
import { useUpsertMissionForm } from "src/core/hooks/folder/useUpsertMissionForm";

type UpsertMissionModalProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  mission: IMission | null;
  setMissionToEdit: (mission: IMission | null) => void;
};

export default function UpsertMissionModal({
  open,
  setOpen,
  mission,
  setMissionToEdit,
}: UpsertMissionModalProps) {
  const { t } = useTranslation();

  const { form, onSubmit, isLoading, missionTypeWithRiskOptions } = useUpsertMissionForm(
    setOpen,
    mission,
    setMissionToEdit
  );

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        className="modal-add-stakeholder w-[480px] max-w-[calc(100vw-40px)] overflow-hidden"
        hideCloseButton
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogHeader className="modal-add-stakeholder-header">
          <DialogTitle>
            {t(mission ? "editMission.modal.title" : "addMission.modal.title")}
          </DialogTitle>
          <DialogDescription className="sr-only">
            {t(mission ? "editMission.modal.description" : "addMission.modal.description")}
          </DialogDescription>
        </DialogHeader>

        <UpsertMissionForm
          form={form}
          onSubmit={onSubmit}
          isLoading={isLoading}
          missionTypeWithRiskOptions={missionTypeWithRiskOptions}
          setOpen={setOpen}
          setMissionToEdit={setMissionToEdit}
          isEdit={mission !== null}
        />
      </DialogContent>
    </Dialog>
  );
}
